import { nextTick } from 'vue'
import { createI18n, useI18n } from 'vue-i18n'

const DEFAULT_LOCALE = 'en-US'
export const SUPPORTED_LOCALES = ['mn-MN', 'en-US']

let _i18n
export const i18n = setupI18n()

const _useAppI18n = () => useI18n()
export const useAppI18n = useI18n

function setupI18n(locale = DEFAULT_LOCALE) {
  const savedLocale = window.localStorage.getItem('locale')

  if (SUPPORTED_LOCALES.includes(savedLocale)) locale = savedLocale

  _i18n = createI18n({
    legacy: false,
    locale: locale,
    fallbackLocale: 'en-US',
  })

  setI18nLanguage(locale)
  loadLocaleMessages(locale)

  return _i18n
}

export function setI18nLanguage(locale) {
  window.localStorage.setItem('locale', locale)
  if (!_i18n) return
  _i18n.global.locale.value = locale
}

export async function loadLocaleMessages(locale) {
  if (!_i18n) return
  const messages = await import(
    `./locales/${locale}.json`
  )
  if (!messages) return
  _i18n.global.setLocaleMessage(locale, messages)

  return nextTick()
}
